(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9847],{

/***/ 69847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostComment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__(45489);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var esm = __webpack_require__(38367);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/common/ConfirmDialog/index.tsx
var ConfirmDialog = __webpack_require__(78257);
// EXTERNAL MODULE: ./components/common/ReportBox/index.tsx
var ReportBox = __webpack_require__(46069);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/PostComment/ThreeDotsMenu/ThreeDotsMenu.module.scss
var ThreeDotsMenu_module = __webpack_require__(73880);
var ThreeDotsMenu_module_default = /*#__PURE__*/__webpack_require__.n(ThreeDotsMenu_module);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
;// CONCATENATED MODULE: ./components/PostComment/ThreeDotsMenu/index.tsx












function ThreeDotsMenu(param) {
    var postId = param.postId, commentId = param.commentId, ownerId = param.ownerId, _isOwnPost = param.isOwnPost, isOwnPost = _isOwnPost === void 0 ? false : _isOwnPost, isOwnComment = param.isOwnComment, parentId = param.parentId;
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var refetchPostComments = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPostComments;
    });
    var ref1 = (0,react.useState)(false), openConfirmReportComment = ref1[0], setOpenConfirmReportComment = ref1[1];
    var ref2 = (0,react.useState)(false), openConfirmReportUser = ref2[0], setOpenConfirmReportUser = ref2[1];
    var ref3 = (0,react.useState)(false), openConfirmDeleteComment = ref3[0], setOpenConfirmDeleteComment = ref3[1];
    var ref4 = (0,react.useState)(false), openConfirmHideComment = ref4[0], setOpenConfirmHideComment = ref4[1];
    var threeDotRef = (0,react.useRef)();
    (0,utils/* useOutsideClick */.O3)(threeDotRef, function() {
        if (show) setShow(false);
    });
    var handleDeleteComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios/* default.delete */.Z["delete"]("/posts/".concat(postId, "/comments/").concat(commentId));
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        setSnackbarMessage({
                            type: "error",
                            text: "コメントの削除が失敗しました"
                        });
                    case 8:
                        setShow(false);
                        setOpenConfirmDeleteComment(false);
                        refetchPostComments(parentId);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function handleDeleteComment() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleHideComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios/* default.post */.Z.post("/posts/comments/".concat(commentId, "/hide"), {
                            is_hide: true
                        });
                    case 3:
                        setSnackbarMessage({
                            type: "success",
                            text: "コメントを非表示しました。"
                        });
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        setSnackbarMessage({
                            type: "error",
                            text: "コメントの非表示が失敗しました"
                        });
                    case 9:
                        setShow(false);
                        setOpenConfirmHideComment(false);
                        refetchPostComments(parentId);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function handleHideComment() {
            return _ref.apply(this, arguments);
        };
    }();
    var content;
    if (isOwnComment) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (ThreeDotsMenu_module_default()).menuWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                onClick: function() {
                    return setOpenConfirmDeleteComment(true);
                },
                style: {
                    color: "#FA553F"
                },
                children: "コメントを削除する"
            })
        });
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (ThreeDotsMenu_module_default()).menuWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    onClick: function() {
                        return setOpenConfirmReportComment(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "post-report",
                            width: 24,
                            height: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "コメント問題をレポートする"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    onClick: function() {
                        return setOpenConfirmReportUser(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "user-report",
                            width: 24,
                            height: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "ユーザーをレポートする"
                        })
                    ]
                }),
                isOwnPost && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    onClick: function() {
                        return setOpenConfirmHideComment(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "post-off",
                            width: 24,
                            height: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "コメントを非表示にする"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ThreeDotsMenu_module_default()).threeDotsMenuWrapper,
        ref: threeDotRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ThreeDotsMenu_module_default()).triggerWrapper,
                onClick: function() {
                    return setShow(!show);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "threedots",
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ThreeDotsMenu_module_default()).contentWrapper,
                style: {
                    display: show ? "block" : "none",
                    width: isOwnComment ? "220px" : "300px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ThreeDotsMenu_module_default()).arrow
                    }),
                    content
                ]
            }),
            openConfirmDeleteComment && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmDeleteComment,
                actionCloseFnc: function() {
                    return setOpenConfirmDeleteComment(false);
                },
                actionSelectedFnc: handleDeleteComment,
                title: "本当に削除しますか？"
            }),
            openConfirmHideComment && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmHideComment,
                actionCloseFnc: function() {
                    return setOpenConfirmHideComment(false);
                },
                actionSelectedFnc: handleHideComment,
                yesText: "非表示する",
                title: "本当に非表示しますか？"
            }),
            openConfirmReportComment && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmReportComment,
                actionCloseFnc: function() {
                    return setOpenConfirmReportComment(false);
                },
                title: "オプション選択",
                withTextBox: true,
                textBox: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (ThreeDotsMenu_module_default()).menuWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://help.postprime.com/hc/ja/requests/new?ticket_form_id=360008586356",
                                target: "_blank",
                                rel: "noopener",
                                children: "著作権侵害の報告"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://help.postprime.com/hc/ja/requests/new?ticket_form_id=360007972215",
                                target: "_blank",
                                rel: "noopener",
                                children: "個人情報に関する苦情"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://help.postprime.com/hc/ja/requests/new?ticket_form_id=360008586376",
                                target: "_blank",
                                rel: "noopener",
                                children: "その他の違反報告"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                marginTop: "20px"
                            },
                            onClick: function() {
                                return setOpenConfirmReportComment(false);
                            },
                            children: "キャンセル"
                        })
                    ]
                })
            }),
            openConfirmReportUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                open: openConfirmReportUser,
                actionCloseFnc: function() {
                    return setOpenConfirmReportUser(false);
                },
                title: "ユーザーをレポートする",
                withTextBox: true,
                textBox: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox/* default */.Z, {
                    targetUserId: ownerId,
                    onDialogSubmit: function() {
                        return setOpenConfirmReportUser(false);
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/PostComment/PostComment.module.scss
var PostComment_module = __webpack_require__(96806);
var PostComment_module_default = /*#__PURE__*/__webpack_require__.n(PostComment_module);
// EXTERNAL MODULE: ./components/common/RichContent/index.tsx + 1 modules
var RichContent = __webpack_require__(8348);
// EXTERNAL MODULE: ./components/common/RoundIcon/index.tsx
var RoundIcon = __webpack_require__(10184);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/BadgeIcon/index.tsx
var BadgeIcon = __webpack_require__(85650);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./components/common/CommentBox/index.tsx
var CommentBox = __webpack_require__(25043);
// EXTERNAL MODULE: ./components/common/TippedItem/index.tsx
var TippedItem = __webpack_require__(7923);
// EXTERNAL MODULE: ./common/utils/membership.ts
var membership = __webpack_require__(77063);
// EXTERNAL MODULE: ./common/utils/pp_tracking.ts
var pp_tracking = __webpack_require__(67027);
// EXTERNAL MODULE: ./components/common/MembershipVipIcon/index.tsx
var MembershipVipIcon = __webpack_require__(756);
;// CONCATENATED MODULE: ./components/PostComment/index.tsx



























function PostCommentItem(param) {
    var postId = param.postId, comment = param.comment, level = param.level, postOwner = param.postOwner, isLocked = param.isLocked, parentId = param.parentId, parentReplyRef = param.parentReplyRef, _isBlocked = param.isBlocked, isBlocked = _isBlocked === void 0 ? false : _isBlocked, _tinyMode = param.// isOpenForSubscription = true,
    tinyMode, tinyMode = _tinyMode === void 0 ? false : _tinyMode;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)(comment.is_liked), isLiked = ref6[0], setIsLiked = ref6[1];
    var ref7 = (0,react.useState)(comment.like_count), likeCount = ref7[0], setLikeCount = ref7[1];
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var user = comment.user_info;
    var isOwnPost = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === postOwner.id;
    var isOwnComment = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === user.id;
    var ref8 = (0,react.useState)(user.is_followed), isFollowed = ref8[0], setIsFollowed = ref8[1];
    var refetchPostComments = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPostComments;
    });
    var ref9 = (0,react.useState)(false), showReplies = ref9[0], setShowReplies = ref9[1];
    var ref10 = (0,react.useState)(false), showReplyBox = ref10[0], setShowReplyBox = ref10[1];
    var selfLastReplyRef = (0,react.useRef)();
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    (0,react.useEffect)(function() {
        setIsFollowed(user === null || user === void 0 ? void 0 : user.is_followed);
    }, [
        user === null || user === void 0 ? void 0 : user.is_followed
    ]);
    (0,react.useEffect)(function() {
        setIsLiked(comment.is_liked);
        setLikeCount(comment.like_count);
    }, [
        comment.is_liked,
        comment.like_count
    ]);
    var shouldRefetchPostComments = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchPostComments;
    });
    var shouldRefetchRepliesCommentId = (0,timeline/* default */.ZP)(function(state) {
        return state.shouldRefetchRepliesCommentId;
    });
    var ref11 = (0,es.useInfiniteQuery)([
        "getReplies",
        (ref = comment.id) === null || ref === void 0 ? void 0 : ref.toString()
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        if (showReplies) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            data: []
                        });
                    case 3:
                        _ctx.next = 5;
                        return axios/* default.get */.Z.get("/posts/comments/".concat(comment.id, "/replies?last_comment_id=").concat(pageParam));
                    case 5:
                        return _ctx.abrupt("return", _ctx.sent.data);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var comments = lastPage === null || lastPage === void 0 ? void 0 : lastPage.data;
            if (comments && comments.length === utils/* COMMENTS_PER_PAGE */.Gu) {
                var lastId = comments[0].id;
                comments.forEach(function(comment) {
                    if (comment.id < lastId) {
                        lastId = comment.id;
                    }
                });
                return lastId;
            }
        },
        enabled: level === 0 && !!comment.id && showReplies,
        refetchOnWindowFocus: false
    }), data = ref11.data, fetchNextPage = ref11.fetchNextPage, hasNextPage = ref11.hasNextPage, refetch = ref11.refetch;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var replies = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var comments = page.data;
            return (0,_to_consumable_array/* default */.Z)(comments).concat((0,_to_consumable_array/* default */.Z)(curr));
        }, []) : [];
    }, [
        pages
    ]);
    (0,react.useEffect)(function() {
        if (shouldRefetchPostComments && shouldRefetchRepliesCommentId === comment.id) {
            void refetch();
        }
    }, [
        shouldRefetchPostComments,
        refetch,
        shouldRefetchRepliesCommentId,
        comment.id, 
    ]);
    var handleMoreClick = function() {
        if (!currentUser) {
            showLogin({});
            return;
        }
        void fetchNextPage();
    };
    var handleLikeClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commentId, isLiked) {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,esm/* track */.j)("Like Comment");
                        if (!currentUser) {
                            _ctx.next = 8;
                            break;
                        }
                        action = isLiked ? "unlike" : "like";
                        if (isLiked) {
                            setIsLiked(false);
                            setLikeCount(function(count) {
                                return count - 1;
                            });
                        } else {
                            setIsLiked(true);
                            setLikeCount(function(count) {
                                return count + 1;
                            });
                        }
                        _ctx.next = 6;
                        return axios/* default.post */.Z.post("/posts/".concat(postId, "/comments/").concat(commentId, "/reaction?action=").concat(action), {});
                    case 6:
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            showLogin({});
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLikeClick(commentId, isLiked) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFollowClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userId, isFollowed) {
            var action;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!currentUser) {
                            _ctx.next = 8;
                            break;
                        }
                        action = isFollowed ? "unfollow" : "follow";
                        if (isFollowed) {
                            setIsFollowed(false);
                        } else {
                            setIsFollowed(true);
                        }
                        _ctx.next = 5;
                        return axios/* default.post */.Z.post("/users/follows", {
                            user_id: userId,
                            action: action
                        });
                    case 5:
                        refetchPostComments(0);
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            showLogin({});
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollowClick(userId, isFollowed) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowReplies = function() {
        if (!currentUser) {
            showLogin({});
            return;
        }
        setShowReplies(true);
    };
    var handleReply = function() {
        handleShowReplies();
        if (isBlocked) return;
        setShowReplyBox(true);
    };
    // Footer
    var timeSinceText = (0,utils/* timeSince */.VG)(new Date(comment.created_at), api/* Language.Ja */.SQ.Ja);
    if (tinyMode) {
        var ref12, ref13, ref14;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((PostComment_module_default()).postCommentWrapper, (0,_define_property/* default */.Z)({}, (PostComment_module_default())["tip-".concat(comment === null || comment === void 0 ? void 0 : (ref12 = comment.user_tipping) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.tipping_package) === null || ref13 === void 0 ? void 0 : ref13.id)], !!(comment === null || comment === void 0 ? void 0 : (ref14 = comment.user_tipping) === null || ref14 === void 0 ? void 0 : ref14.tipping_package))),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PostComment_module_default()).avatar,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                        user: user,
                        width: 33,
                        height: 33,
                        enableClick: true,
                        hasRing: true,
                        emotion: user.emotion
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((PostComment_module_default()).contentBox, (PostComment_module_default()).tinyMode),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostComment_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                            text: comment.text,
                            mentionTargets: comment.mentions
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((PostComment_module_default()).postCommentWrapper, (0,_define_property/* default */.Z)({}, (PostComment_module_default())["tip-".concat(comment === null || comment === void 0 ? void 0 : (ref1 = comment.user_tipping) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tipping_package) === null || ref2 === void 0 ? void 0 : ref2.id)], !!(comment === null || comment === void 0 ? void 0 : (ref3 = comment.user_tipping) === null || ref3 === void 0 ? void 0 : ref3.tipping_package))),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostComment_module_default()).avatar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundIcon/* default */.Z, {
                            user: user,
                            width: 35,
                            height: 35,
                            enableClick: true,
                            hasRing: true,
                            emotion: user.emotion
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PostComment_module_default()).contentBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PostComment_module_default()).userInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PostComment_module_default()).nameJob,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(user.username),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (PostComment_module_default()).userNameText,
                                                        title: user.name,
                                                        children: user.name
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PostComment_module_default()).userJobText,
                                                title: user.job,
                                                children: user.job
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PostComment_module_default()).badge,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeIcon/* default */.Z, {
                                            badge: user.badge,
                                            width: 34,
                                            height: 34
                                        })
                                    }),
                                    ((0,membership/* isMembershipAccount */.Qx)(user) || (0,membership/* isIzanaviMember */.Wj)(user)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PostComment_module_default()).membershipIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipVipIcon/* default */.Z, {
                                            packageName: user === null || user === void 0 ? void 0 : (ref4 = user.membership) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.membership_package) === null || ref5 === void 0 ? void 0 : ref5.package_name,
                                            isIzanavi: (0,membership/* isIzanaviMember */.Wj)(user),
                                            width: 60,
                                            height: 34,
                                            onClick: function() {
                                                setShowMembershipPayDialog({
                                                    open: true,
                                                    showMembershipStatus: false,
                                                    screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
                                                });
                                            }
                                        })
                                    }),
                                    (comment === null || comment === void 0 ? void 0 : comment.user_tipping) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (PostComment_module_default()).tippedItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TippedItem/* default */.Z, {
                                            tippedInfo: Object.assign({}, comment.user_tipping, {
                                                user: comment.user_info
                                            })
                                        })
                                    }),
                                    !isFollowed && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== (user === null || user === void 0 ? void 0 : user.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "follow",
                                        width: 32,
                                        height: 32,
                                        isOn: isFollowed,
                                        hasOn: true,
                                        hasHover: true,
                                        onClick: function() {
                                            return handleFollowClick(user.id, isFollowed);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PostComment_module_default()).content,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichContent/* default */.Z, {
                                    text: comment.text,
                                    mentionTargets: comment.mentions
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PostComment_module_default()).footerActions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PostComment_module_default()).timeSince,
                                        children: timeSinceText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PostComment_module_default()).icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                name: "heart",
                                                width: 16,
                                                height: 16,
                                                isOn: isLiked,
                                                hasOn: true,
                                                onClick: function() {
                                                    return handleLikeClick(comment.id, isLiked);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((PostComment_module_default()).number, (0,_define_property/* default */.Z)({}, (PostComment_module_default()).liked, isLiked)),
                                                children: likeCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PostComment_module_default()).icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                name: "comment",
                                                width: 16,
                                                height: 16,
                                                hasOn: true,
                                                isOn: comment.reply_count > 0,
                                                onClick: function() {
                                                    return handleReply();
                                                }
                                            }),
                                            comment.reply_count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PostComment_module_default()).number,
                                                children: comment.reply_count
                                            })
                                        ]
                                    }),
                                    currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDotsMenu, {
                                        postId: postId,
                                        commentId: comment.id,
                                        ownerId: user.id,
                                        isOwnComment: isOwnComment,
                                        isOwnPost: isOwnPost,
                                        parentId: level === 0 ? comment.id : parentId
                                    })
                                ]
                            }),
                            !isLocked && showReplyBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBox/* default */.Z, {
                                postId: postId,
                                parentId: level === 0 ? comment.id : parentId,
                                isReplyBox: true,
                                isLocked: isLocked,
                                initText: isOwnComment ? "" : "@".concat(comment.user_info.name, " "),
                                setShowReplyBox: setShowReplyBox,
                                callback: function() {
                                    setShowReplies(true);
                                    if (isMobileScreen) return;
                                    if (level === 0) {
                                        if (selfLastReplyRef && selfLastReplyRef.current) window.scrollTo(0, selfLastReplyRef.current.offsetTop + 50);
                                    } else {
                                        if (parentReplyRef && parentReplyRef.current) window.scrollTo(0, parentReplyRef.current.offsetTop + 50);
                                    }
                                },
                                mentionTarget: comment.user_info
                            }),
                            level === 0 && comment.reply_count > 0 && !showReplies && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PostComment_module_default()).repliesTitle,
                                onClick: function() {
                                    return handleShowReplies();
                                },
                                children: [
                                    comment.reply_count,
                                    "件の返信を表示"
                                ]
                            })
                        ]
                    })
                ]
            }),
            level === 0 && comment.reply_count > 0 && showReplies && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PostComment_module_default()).replies,
                children: [
                    comment.reply_count > replies.length && hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostComment_module_default()).more,
                        onClick: handleMoreClick,
                        children: "以前のコメントを見る"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        initial: false,
                        children: replies && replies.map(function(reply) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0,
                                    y: -150
                                },
                                animate: {
                                    opacity: 1,
                                    y: 0
                                },
                                exit: {
                                    opacity: 0,
                                    x: "70%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PostComment_module_default()).reply,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCommentItem, {
                                        comment: reply,
                                        level: 1,
                                        postOwner: postOwner,
                                        isBlocked: isBlocked,
                                        postId: postId,
                                        isLocked: isLocked,
                                        parentId: comment.id,
                                        parentReplyRef: selfLastReplyRef
                                    })
                                }, reply.id)
                            }, reply.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: selfLastReplyRef
                    })
                ]
            })
        ]
    });
}
var MemoizedPostComment = /*#__PURE__*/ react.memo(PostCommentItem);
/* harmony default export */ var PostComment = (MemoizedPostComment);


/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38367);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87066);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88767);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52795);
/* harmony import */ var components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10184);
/* harmony import */ var components_common_ProgressRing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8325);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8405);
/* harmony import */ var components_common_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98133);
/* harmony import */ var components_common_TextEditor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55646);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22467);
/* harmony import */ var _CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(77029);
/* harmony import */ var _CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var service_post__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87350);
/* harmony import */ var common_utils_debounce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80582);




















function CommentBox(param) {
    var postId = param.postId, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, _lockMessage = param.lockMessage, lockMessage = _lockMessage === void 0 ? "" : _lockMessage, _parentId = param.parentId, parentId = _parentId === void 0 ? null : _parentId, _isReplyBox = param.isReplyBox, isReplyBox = _isReplyBox === void 0 ? false : _isReplyBox, setShowReplyBox = param.setShowReplyBox, mentionTarget = param.mentionTarget, _initText = param.initText, initText = _initText === void 0 ? "" : _initText, callback = param.callback;
    var charLimit = 300;
    var selfRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    var refetchPostComments = (0,store_timeline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return state.refetchPostComments;
    });
    var setSnackbarMessage = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isProcessing = ref[0], setIsProcessing = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), textPolicies = ref1[0], setTextPolicies = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), blackUrls = ref2[0], setBlackUrls = ref2[1];
    var usingTextPolices = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return textPolicies.filter(function(po) {
            return po.level === service_post__WEBPACK_IMPORTED_MODULE_12__/* .PolicyLevel.SuperHigh */ .VV.SuperHigh;
        });
    }, [
        textPolicies
    ]);
    var hasPolicyError = usingTextPolices.length > 0 || blackUrls.length > 0;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), postable = ref3[0], setPostable = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isFocused = ref4[0], setFocused = ref4[1];
    // Text editor
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), plainText = ref5[0], setPlainText = ref5[1];
    var textLength = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return plainText.length;
    }, [
        plainText
    ]);
    var textEditorRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var isMobile = (0,common_utils__WEBPACK_IMPORTED_MODULE_11__/* .useMediaQuery */ .ac)("(max-width: 767px)");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setPostable(textLength > 0 && textLength <= charLimit);
    }, [
        textLength,
        charLimit
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (textEditorRef.current) {
            var text = textEditorRef.current.getContent();
            if (text) {
                textEditorRef.current.reset();
            }
        }
    }, [
        postId
    ]);
    var isInlineMode = !isFocused && textLength === 0 && !isReplyBox;
    var ref6 = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(plainText) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,service_post__WEBPACK_IMPORTED_MODULE_12__/* .checkPolicyCommentText */ .mf)(plainText));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(plainText) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function(data) {
            var ref, ref1;
            // only update when have different data
            var policies = (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.words) || [];
            var isSame = policies.length === textPolicies.length && policies.every(function(pl) {
                return textPolicies.some(function(policy) {
                    return policy.name === pl.name;
                });
            });
            if (!isSame) setTextPolicies(policies);
            var urls = (data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.urls) || [];
            var isSameUrls = urls.length === blackUrls.length && urls.every(function(blUrl) {
                return blackUrls.some(function(url) {
                    return url.url === blUrl.url;
                });
            });
            if (!isSameUrls) setBlackUrls(urls);
            setIsProcessing(false);
        },
        onError: function() {
            setIsProcessing(false);
        }
    }), checkPostText = ref6.mutate;
    var debouncedCheckPostText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,common_utils_debounce__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(checkPostText, 1000);
    }, [
        checkPostText
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsProcessing(true);
        debouncedCheckPostText(plainText);
    }, [
        plainText,
        debouncedCheckPostText
    ]);
    // Make comment
    var ref7 = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useMutation)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var content, hasMention;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    content = textEditorRef.current.getContent();
                    hasMention = mentionTarget && content.includes("@".concat(mentionTarget.name));
                    if (hasMention) {
                        content = content.replace("@".concat(mentionTarget.name), "@".concat(mentionTarget.id));
                    }
                    _ctx.next = 5;
                    return axios__WEBPACK_IMPORTED_MODULE_15__/* ["default"].post */ .Z.post("/posts/".concat(postId, "/comments"), {
                        text: content.trim(),
                        parent_id: parentId,
                        mentions: hasMention ? [
                            mentionTarget.id
                        ] : []
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        onSuccess: function() {
            (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_16__/* .track */ .j)("Send Comment");
            textEditorRef.current.reset();
            setShowReplyBox && setShowReplyBox(false);
            callback && callback();
            refetchPostComments(parentId);
            setIsProcessing(false);
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "コメントが失敗しました"
            });
            setIsProcessing(false);
        }
    }), isMakingComment = ref7.isLoading, makeComment = ref7.mutate;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!textEditorRef.current) return;
        textEditorRef.current.forceRender();
    }, [
        textPolicies,
        blackUrls
    ]);
    var handleMakeComment = function() {
        if (!currentUser) {
            showLogin({});
        } else {
            makeComment();
        }
    };
    var avatarEl = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().avatar),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            user: currentUser,
            width: 35,
            height: 35,
            hasRing: true,
            emotion: currentUser === null || currentUser === void 0 ? void 0 : currentUser.emotion
        })
    });
    var handleTextAreaFocus = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return setFocused(true);
    }, []);
    var handleClickAway = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return setFocused(false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().commentBox), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().locked), isLocked)),
            ref: selfRef,
            children: [
                avatarEl,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    onClickAway: handleClickAway,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().inputBox), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().expanded), !isInlineMode)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().textInputWrapper),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().textInput),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_TextEditor__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        ref: textEditorRef,
                                        setPlainText: setPlainText,
                                        placeholder: isLocked ? lockMessage : "コメントする",
                                        onFocus: handleTextAreaFocus,
                                        blackUrls: blackUrls,
                                        readOnly: isLocked,
                                        textPolicies: usingTextPolices,
                                        initialText: initText,
                                        charLimit: charLimit,
                                        mentionTarget: mentionTarget
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().footer),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().rightSide), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().expanded), !isInlineMode)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().progress),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ProgressRing__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                radius: 22,
                                                current: textLength,
                                                total: charLimit
                                            })
                                        }),
                                        isReplyBox && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            style: {
                                                marginRight: "8px"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                onClick: function() {
                                                    return setShowReplyBox && setShowReplyBox(false);
                                                },
                                                text: "キャンセル",
                                                rounded: true,
                                                verticalPadding: isMobile ? 5 : 6,
                                                alternateColor: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().createBtn),
                                            children: [
                                                hasPolicyError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_17___default().alert),
                                                    children: [
                                                        "投稿ポリシーに違反している可能性があります。詳しくは",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            target: "_blank",
                                                            href: common_utils__WEBPACK_IMPORTED_MODULE_11__/* .POST_POLICY_URL */ .BV,
                                                            children: "投稿ポリシー"
                                                        }),
                                                        "をご覧ください。"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    disabled: !postable || isProcessing || hasPolicyError,
                                                    onClick: function() {
                                                        if (isProcessing) return;
                                                        handleMakeComment();
                                                    },
                                                    text: "投稿",
                                                    rounded: true,
                                                    verticalPadding: isMobile ? 5 : 6,
                                                    isLoading: isMakingComment
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 96806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postCommentWrapper":"PostComment_postCommentWrapper__eFJWK","tip-1":"PostComment_tip-1__FkWP8","tip-2":"PostComment_tip-2__Lf39N","tip-3":"PostComment_tip-3__aSnk1","tip-4":"PostComment_tip-4__niDKx","tip-5":"PostComment_tip-5__g29sK","contentBox":"PostComment_contentBox__1Id_Z","content":"PostComment_content__3BOs8","avatar":"PostComment_avatar__4ftXN","userInfo":"PostComment_userInfo__HNsFA","nameJob":"PostComment_nameJob__8CWn9","userNameText":"PostComment_userNameText__4MnA6","userJobText":"PostComment_userJobText__YVcIv","badge":"PostComment_badge__or7df","membershipIcon":"PostComment_membershipIcon__WR41e","tippedItem":"PostComment_tippedItem__m_RIa","tinyMode":"PostComment_tinyMode__OytnL","footerActions":"PostComment_footerActions__gYYgQ","icon":"PostComment_icon__0u_2Y","number":"PostComment_number__DjBKP","liked":"PostComment_liked__ghI0R","timeSince":"PostComment_timeSince__oNRft","repliesTitle":"PostComment_repliesTitle__CaKL6","replies":"PostComment_replies__fW45Y","reply":"PostComment_reply__Sw60M","more":"PostComment_more__5l491"};

/***/ }),

/***/ 73880:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"threeDotsMenuWrapper":"ThreeDotsMenu_threeDotsMenuWrapper__d2m60","triggerWrapper":"ThreeDotsMenu_triggerWrapper__B0S_S","contentWrapper":"ThreeDotsMenu_contentWrapper__INwaO","arrow":"ThreeDotsMenu_arrow__OFJsH","menuWrapper":"ThreeDotsMenu_menuWrapper__psCWB","dialogWrapper":"ThreeDotsMenu_dialogWrapper__J1rEP","header":"ThreeDotsMenu_header__iRt34","buttons":"ThreeDotsMenu_buttons__wvlXB","button":"ThreeDotsMenu_button__s97WA"};

/***/ }),

/***/ 77029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commentBox":"CommentBox_commentBox__hIsmF","locked":"CommentBox_locked__UOCvh","inputBox":"CommentBox_inputBox__o4xFx","textInputWrapper":"CommentBox_textInputWrapper__9gTCz","textInput":"CommentBox_textInput__ebp0V","footer":"CommentBox_footer__9k4oT","avatar":"CommentBox_avatar__lu3lz","expanded":"CommentBox_expanded__5MtbI","fullScreenBtn":"CommentBox_fullScreenBtn__7FpgE","rightSide":"CommentBox_rightSide__Vp3fE","progress":"CommentBox_progress__isMAa","createBtn":"CommentBox_createBtn__kp_Bg","alert":"CommentBox_alert__cy0xj","text":"CommentBox_text__B76OM"};

/***/ })

}]);